// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__3NxGd","content":"LayoutSettings_content__ILNvA"};